import { queryDpMessage } from '@tencent/wphk-components-dp-loader';
import { cacheFunc } from '@tencent/wphk-base-utils';
import type { QryDpMsgRes } from '@tencent/wphk-components-dp-loader/src/types';
import { getLanStrVal } from '../utils';

/** 投放页面id */
const DP_PAGE = '110004000037';
/** 投放位置id */
const DP_POSITION = '1100040000370012';

/**
 * 获取抢券有 so 广告
 * @returns
 */
const cacheRequestConfig = cacheFunc(queryDpMessage);

/**
 *  获取商圈配置信息
 * @returns
 */
export async function getMallConfig() {
  const dpInfo = await cacheRequestConfig({ dpPage: DP_PAGE, dpPositions: [DP_POSITION] });
  return formatConfig(dpInfo as QryDpMsgRes);;
}

function formatConfig(dpInfo: QryDpMsgRes) {
  const list: any[] = (dpInfo.dpList || []).map(item => ({
    dpId: item.dpId,
    ...item.contentBaseData,
  }));
  return list.map((cfg) => {
    const { spid = '', desc = {}, addr = {}, bgImg = '', bgColor = '', needAD = 0, adJumpUrl = {}, adImgUrl = {} } = cfg;
    return {
      dpId: cfg.dpId as string,
      id: spid,
      desc: getLanStrVal(desc),
      addr: getLanStrVal(addr),
      bgColor,
      bgImgUrl: bgImg,
      needAD: !!needAD,
      jumpUrl: getLanStrVal(adJumpUrl),
      imgUrl: getLanStrVal(adImgUrl),
    };
  });
}
